// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2kECZ","checkboxCol":"Table_checkboxCol__3k2RW","emailCol":"Table_emailCol__1Ddkr","actionCol":"Table_actionCol__VWDZI"};